// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal_dev_settings___BV_modal_outer_[data-v-dfd5e984] {\n  z-index: 2000 !important;\n}", ""]);
// Exports
module.exports = exports;
